export default __webpack_public_path__ + "static/media/QuitSmoking.ee03d569.pdf";